import { options } from '@/react/portainer/settings/AuthenticationView/oauth-options';

export default class OAuthProviderSelectorController {
  constructor() {
    this.options = options;
  }
}
